import { render } from "./TrainingDetail_CDO.vue?vue&type=template&id=48ab0739&scoped=true"
import script from "./TrainingDetail_CDO.vue?vue&type=script&lang=js"
export * from "./TrainingDetail_CDO.vue?vue&type=script&lang=js"

import "./TrainingDetail_CDO.vue?vue&type=style&index=0&id=48ab0739&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ab0739"]])

export default __exports__